import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';

const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const useStyles = makeStyles(theme => ({
	table: {
		minWidth: '640px'
	},
	tableWrapper: {
		overflowX: 'auto',
		overflowY: 'hidden',
		position: 'relative'
	},
	schematicCell: {
		'&:hover': {
			cursor: 'pointer'
		},
		width: 220,
		minWidth: 170,
		padding: 10,
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(0.5),
		paddingRight: theme.spacing(5)
	},
	selectButtonCell: {
		display: 'inline-block',
		padding: 0,
		textAlign: 'center'
	},
	linkContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	linkStyle: {
		display: 'flex',
		lineHeight: '1.5rem',
		marginTop: 0
	},
	partNumberCell: {
		display: 'inline-block',
		whiteSpace: 'nowrap'
	},
	partNumberCellLink: {
		marginRight: 2
	},
	datasheetIconButton: {
		margin: '0px -3px 3px 0px'
	},
	backdrop: {
		position: 'absolute',
		zIndex: theme.zIndex.appBar - 2,
		color: COLORS.PRIMARY,
		backgroundColor: 'rgba(255, 255, 255, 0.9)'
	},
	noDesignsFoundTableCell: {
		borderBottom: 0
	},
	noDesignsFoundContainer: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(2)
	},
	selectButton: {
		marginTop: '0.5rem',
		marginBottom: isFirefox ? '0.5rem' : '-0.5rem',
		width: '8rem',
		'& .MuiTypography-root': {
			fontWeight: 600
		}
	},
	centerAlign: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		marginBottom: 0
	}
}));
